import { render, staticRenderFns } from "./LedgerConfigPageTemplate.vue?vue&type=template&id=bfb54ce6"
import script from "./LedgerConfigPageTemplate.vue?vue&type=script&lang=js"
export * from "./LedgerConfigPageTemplate.vue?vue&type=script&lang=js"
import style0 from "./LedgerConfigPageTemplate.vue?vue&type=style&index=0&id=bfb54ce6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports